var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#E3F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1495 21.058C19.4133 20.3258 18.9575 19.3119 18.9575 18.1915C18.9575 17.0711 19.4133 16.0572 20.1495 15.325C19.7256 15.1169 19.2488 15 18.7447 15C16.9821 15 15.5532 16.4289 15.5532 18.1915C15.5532 19.9541 16.9821 21.383 18.7447 21.383C19.2488 21.383 19.7256 21.2661 20.1495 21.058Z",
    fill: "#0091CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8086 18.1915C19.8086 16.4289 21.2375 15 23.0001 15C24.7627 15 26.1916 16.4289 26.1916 18.1915C26.1916 19.9541 24.7627 21.383 23.0001 21.383C21.2375 21.383 19.8086 19.9541 19.8086 18.1915Z",
    fill: "#0091CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8506 15.325C26.5868 16.0572 27.0426 17.0711 27.0426 18.1915C27.0426 19.3119 26.5868 20.3258 25.8506 21.058C26.2744 21.2661 26.7513 21.383 27.2554 21.383C29.018 21.383 30.4468 19.9541 30.4468 18.1915C30.4468 16.4289 29.018 15 27.2554 15C26.7513 15 26.2744 15.1169 25.8506 15.325Z",
    fill: "#0091CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2554 25.851C17.2554 24.0884 18.6842 22.6595 20.4469 22.6595H25.5532C27.3159 22.6595 28.7447 24.0884 28.7447 25.851C28.7447 27.6137 27.3159 29.0425 25.5532 29.0425H20.4469C18.6842 29.0425 17.2554 27.6137 17.2554 25.851Z",
    fill: "#0091CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C13 23.2374 14.4289 21.8085 16.1915 21.8085H20.4468C18.2142 21.8085 16.4043 23.6184 16.4043 25.8511C16.4043 26.7233 16.6805 27.531 17.1503 28.1915H16.1915C14.4289 28.1915 13 26.7626 13 25Z",
    fill: "#0091CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5958 25.8511C29.5958 26.7233 29.3195 27.531 28.8497 28.1915H29.8085C31.5712 28.1915 33 26.7626 33 25C33 23.2374 31.5712 21.8085 29.8085 21.8085H25.5532C27.7859 21.8085 29.5958 23.6184 29.5958 25.8511Z",
    fill: "#0091CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomers);
export default __webpack_public_path__ + "static/media/New Customers.a474e7bcee24ae35ff7289ae682a4990.svg";
export { ForwardRef as ReactComponent };